import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'yearsTranslate',
  standalone: false
})
export class YearsTranslatePipe implements PipeTransform {
  private translate = inject(TranslateService);

  public transform(years: number): string {

    // For non-integer values (e.g. 0.5, 1.2, 3.5), always use the generic plural form
    if (!Number.isInteger(years) && years > 0) {
      return years + this.translate.instant('global.years.5plus');
    }

    if (years < 1) {
      throw new Error('Unsupported years translation, years: ' + years);
    }

    if (years === 1) {
      return years + this.translate.instant('global.years.1');
    }

    if (years > 1 && years < 5) {
      return years + this.translate.instant('global.years.2-4');
    }

    return years + this.translate.instant('global.years.5plus');

  }
}